export default {"src":"/_next/static/media/ProductSizeIconRed.b32a238a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};